



































import { Component, mixins } from '@niknevis/vue-modules'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import AdminInvoiceCreateButton from '@/modules/invoice/components/admin/AdminInvoiceCreateButton.vue'
import { getTransactionColumnsInAdmin } from '@/modules/transaction/models/columns/admin-transaction.column'
import AdminTransactionTableRow from '@/modules/transaction/components/admin/table/AdminTransactionTableRow.vue'
import { TransactionCollectionType } from '@/modules/transaction/models/transaction-collection'
import { DatePresetTypes, Filter, FilterTypes } from '@/modules/common/filter/filter'
import collect from 'collect.js'
import AdminUserSearchFilter from '@/modules/user/components/admin/AdminUserSearchFilter.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'لیست تراکنش ها'
  },
  metaInfo: {
    title: 'لیست تراکنش ها'
  },
  components: {
    AdminInvoiceCreateButton,
    TesTable,
    FilterRow,
    PaginationWithInput
  }
})
export default class IndexPage extends mixins(QsPaginatableMixin, QsSearchableMixin) {
  @ProvideReactive()
  @Prop() transactions: TransactionCollectionType
  private rowComponent = AdminTransactionTableRow
  private columns = getTransactionColumnsInAdmin()

  private filters = [
    new Filter({
      type: FilterTypes.Select,
      title: 'وضعیت',
      key: 'status',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.transactions.statuses)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'نوع درگاه',
      key: 'gateway',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.transactions.gateways)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'نام درگاه',
      key: 'online_gateway_title',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.transactions.online_gateways)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'مدل تراکنش',
      key: 'transactional_type',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.transactions.transactional_types)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Custom,
      key: 'user',
      title: 'کاربر',
      typeMode: false,
      component: AdminUserSearchFilter
    }),
    new Filter({
      type: FilterTypes.DateRange,
      presets: [
        DatePresetTypes.today,
        DatePresetTypes.yesterday,
        DatePresetTypes.currentWeek,
        DatePresetTypes.currentMonth,
        DatePresetTypes.custom
      ],
      title: 'تاریخ پرداخت',
      holder: 'انتخاب کنید',
      keys: {
        from: 'paid_at_from',
        to: 'paid_at_to'
      }
    })
  ]

  protected get model(): any {
    return this.transactions
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }
}
